<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-monitor-log g-main-wrapper">
      <!-- filter -->
      <monitor-log-filter placeholder="请输入规则ID或者名称" @on-change="filterData" @on-search="searchFilterData" />
      <div class="c-table-list">
        <Viewport v-model="tableHeight">
          <monitor-log-table
            :loading="loading"
            :height="tableHeight"
            :data="tableList"
            :columns="tableCol"
            @on-refresh="getData"
          ></monitor-log-table>
          <Page
            show-total
            show-sizer
            show-elevator
            :total="total"
            :current.sync="pageIndex"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            @on-change="changePageIndex"
            @on-page-size-change="changePageSize"
            class="c-table-page"
            size="small"
          />
        </Viewport>
      </div>
    </div>
  </Layout>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/monitor_log_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { getAdLogList } from '@/api/manage.model'
import MonitorLogFilter from './components/monitor-log-filter'
import MonitorLogTable from './components/monitor-log-table.vue'

export default {
  name: 'monitorlog',
  mixins: [mixin],
  components: { MonitorLogFilter, MonitorLogTable },
  data() {
    return {
      tableHeight: 330
    }
  },
  methods: {
    getData(filter) {
      let params = {
        page_id: this.pageIndex,
        page_size: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 请求数据
      this.loading = true
      getAdLogList(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              ret.launchOpName = ret.launchOpId === null ? '-' : ret.launchOpName
              return ret
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('MONITOR_LOG_PAGESIZE', size)
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('MONITOR_LOG_PAGESIZE')) || 20
    this.tableCol = columns
    this.sort = 'create_time'
    this.order = 'desc'
  }
}
</script>
<style lang="css" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
